import styled from 'styled-components'
import Button from 'components/Button'
import {
  FormControl,
  FormGroup,
  ControlLabel,
  Glyphicon
} from 'react-bootstrap'

const FormWrapper = styled.div`
  position: absolute;
  width: 365px;
  top: 13%;
  left: 25%;
  background: var(--white);
  padding: 20px;
  border: 1px solid var(--light-gray);
  border-radius: 3px;
  box-shadow: 10px 10px 64px 0px rgba(0, 0, 0, 0.15);
  z-index: 600;
  text-align: center;

  .form-control {
    background: #f8f8f8;
    border-color: #ebf0f1;
    color: var(--main-color);
  }

  .form-control:focus {
    border-color: #ebf0f1;
  }

  .form-control::placeholder {
    color: var(--main-color);
  }

  @media only screen and (max-width: 768px) {
    z-index: 800;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

const SubmitButton = styled(Button)`
  padding: 7px 25px;
  display: inline-block;
  margin: 5px;
  color: var(--text-on-buttons);
  background: ${({ disabled, color, disabledButtonColor }) =>
    disabled ? disabledButtonColor : color};
`

const InputWrapper = styled.div`
  width: 321px;
  margin-right: 20px;
  display: inline-block;
  vertical-align: middle;
`

const HideButton = styled.button`
  background: none;
  border: none;
  position: absolute;
  top: 7px;
  right: 2px;

  &:hover {
    color: var(--main-color);
  }
`

const FeedbackForm = ({
  handleClick,
  clientId,
  handleChange,
  clientInput,
  validationMessage,
  validInput,
  inputPlaceholder,
  inputInfo,
  hideFeedback,
  feedbackButtons: {
    disabledButtonColor,
    leftButtonText,
    leftButtonColor,
    rightButtonText,
    rightButtonColor,
    optional1ButtonText,
    optional1ButtonColor,
    optional2ButtonText,
    optional2ButtonColor
  }
}) => {
  return (
    <FormWrapper>
      <HideButton onClick={hideFeedback}>
        <Glyphicon glyph="remove" />
      </HideButton>
      <form
        onSubmit={e => {
          e.preventDefault()
          handleClick(true)
        }}
      >
        {clientInput && (
          <FormGroup validationState={validInput}>
            <ControlLabel>{validationMessage}</ControlLabel>
            <InputWrapper>
              <FormControl
                type="text"
                required
                name="clientId"
                value={clientId}
                onChange={handleChange}
                placeholder={inputPlaceholder}
                autoFocus
              />
            </InputWrapper>
          </FormGroup>
        )}

        <h4>{inputInfo || 'Has the issue been resolved?'}</h4>
        <SubmitButton
          disabled={validInput !== 'success'}
          type="button"
          onClick={() => handleClick(true)}
          color={leftButtonColor || '#2ecc71'}
          disabledButtonColor={disabledButtonColor || '#595959'}
        >
          {leftButtonText || 'Yes'}
        </SubmitButton>
        <SubmitButton
          disabled={validInput !== 'success'}
          type="button"
          onClick={() => handleClick(false)}
          color={rightButtonColor || '#e3524f'}
          disabledButtonColor={disabledButtonColor || '#595959'}
        >
          {rightButtonText || 'No'}
        </SubmitButton>
        {optional1ButtonText && (
          <SubmitButton
            disabled={validInput !== 'success'}
            type="button"
            onClick={() => handleClick(optional1ButtonText)}
            color={optional1ButtonColor || '#2ecc71'}
            disabledButtonColor={disabledButtonColor || '#595959'}
          >
            {optional1ButtonText}
          </SubmitButton>
        )}
        {optional2ButtonText && (
          <SubmitButton
            disabled={validInput !== 'success'}
            type="button"
            onClick={() => handleClick(optional2ButtonText)}
            color={optional2ButtonColor || '#2ecc71'}
            disabledButtonColor={disabledButtonColor || '#595959'}
          >
            {optional2ButtonText}
          </SubmitButton>
        )}
      </form>
    </FormWrapper>
  )
}

export default FeedbackForm
